import React, {useEffect, useState} from "react"
import {AiOutlineClose} from "react-icons/ai";
import "./points.scss"
import {DropDownCheck, PointIcon, SFilterIcon} from "../../../../../assets/icons/defaultIcons";
import {ProgressService} from "../../../../services/progress-api.service";
import dayjs from "dayjs";
import {Dropdown} from "antd";
import PointsListSkeleton from "../../../skeletons/home/points/PointsListSkeleton";
import NoRecord from "../../../../components/dashboard/no-record/NoRecord";

export default function PointsList({close}) {
    const [pointsData, setPointsData] = useState([])
    const [selectedItem, setSelectedItem] = useState('Weekly');
    const [loader , setLoader] = useState(false)

    async function GetPointsData(filterType = 40, selected = 'Weekly') {
        setSelectedItem(selected)
        let showQuarterly = false
        let showMonthly = false
        let showWeekly = true

        switch (filterType) {
            case 10:
                showQuarterly = true
                showMonthly = false
                showWeekly = false
                break
            case 20:
                showQuarterly = false
                showMonthly = true
                showWeekly = false
                break
            case 30:
                showQuarterly = false
                showMonthly = false
                showWeekly = true
                break
            default:
                showQuarterly = false
                showMonthly = false
                showWeekly = true
                break
        }

        setLoader(true)
        const response = await ProgressService.getProgressData(showQuarterly, showMonthly, showWeekly);

        if(response?.data?.status){
            setPointsData(response.data?.data?.data)
            setLoader(false)
        }
    }


    useEffect(()=>{
        GetPointsData()
    },[])

    const items = [
        {
            key: '1',
            label: (
                <a onClick={()=>{GetPointsData(30, 'Weekly')}} className={'d-flex justify-content-between w-100'}>
                    Weekly {selectedItem === 'Weekly' &&  <span><DropDownCheck/></span> }
                </a>
            ),
        },
        {
            key: '2',
            label: (
                <a onClick={()=>{GetPointsData(20, 'Monthly')}} className={'d-flex justify-content-between w-100'}>
                    Monthly {selectedItem === 'Monthly' &&  <span><DropDownCheck/></span> }
                </a>
            ),
        },
        {
            key: '3',
            label: (
                <a onClick={()=>{GetPointsData(10, 'Quaterly')}} className={'d-flex justify-content-between w-100'}>
                    Quaterly {selectedItem === 'Quaterly' &&  <span><DropDownCheck/></span> }
                </a>
            ),
        },
    ];


    if(loader){
        return <PointsListSkeleton close={close}/>
    }

    return(
        <div className={'points-list'}>
            <div className={'points-list-header'}>
                <h3>
                    <span className={'heading-streak-modal'}>   <i>Points Earn</i>
                        <Dropdown menu={{ items }} placement="bottomLeft" trigger={'click'} loading={loader} onClick={(e)=>console.log("onclick event", e)}>
                            <span className={'theme-dropdown-1'}><SFilterIcon/>  {selectedItem ? selectedItem : ''}</span>
                        </Dropdown>
                    </span>
                    <span className={'close-btn'} onClick={()=>{close(false)}}><AiOutlineClose /> </span>
                </h3>
            </div>
            <div className={'points-list-details'}>
                {
                    pointsData.length > 0 ?
                        <ul>
                            {
                                selectedItem !== '' && pointsData?.map((item,index)=>{
                                    return(
                                        <li key={index}>
                                            {
                                                selectedItem === 'Weekly' &&
                                                <h4>{dayjs(`${item.year}-${item.month}-${item.day}`).format('dddd')}</h4>
                                            }
                                            {
                                                selectedItem === 'Monthly' &&
                                                <h4>Week {item.week}</h4>
                                            }
                                            {
                                                selectedItem === 'Quaterly' &&
                                                <h4>{dayjs(`${item.year}-${item.month}`).format('MMMM')}</h4>

                                            }

                                            <ul>
                                                {
                                                    item.records.map((it,ind)=>{
                                                        return(
                                                            <li key={ind}>
                                                                <p>Points earned on completing {it.questionSnapshot.question ? it.questionSnapshot.question : it.questionSnapshot.category} questions  <span>+{it.points} <PointIcon/></span></p>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                        :
                        <NoRecord/>
                }

            </div>
        </div>
    )
}